// Vimeo Hover Play
const vimeoHover = () => {
    const vimeoParent = document.querySelectorAll('[data-hover-play="true"]');

    vimeoParent?.forEach((parent) => {
       const iframe = parent.querySelector('iframe');

       if (iframe) {
          const player = new Vimeo.Player(iframe);

          parent.addEventListener('mouseenter', () => {
             player.play().catch(error => {
                console.error('Error playing the video:', error.name);
             });
          });

          parent.addEventListener('mouseleave', () => {
             player.pause().catch(error => {
                console.error('Error pausing the video:', error.name);
             });
          });
       }
    });
}

vimeoHover()
window.vimeoHover = vimeoHover()


// Iframe Fit
const videoFit = document.querySelectorAll('[data-iframe-fit]');

const setScale = (parent, iframe) => {
   const videoAR = parent.clientWidth / parent.clientHeight;
   const iframeAR = 16 / 9;

   let iframeScale = 1;
   if (videoAR > iframeAR) {
      iframeScale = videoAR / iframeAR;
   } else {
      iframeScale = iframeAR / videoAR;
   }

   iframe.style.transform = `scale(${iframeScale})`;
}

videoFit?.forEach((parent) => {
   const iframe = parent.querySelector('iframe');
   setScale(parent, iframe);

   window.addEventListener('resize', () => setScale(parent, iframe))
})

// Iframe Modal
const iframeModals = document.querySelectorAll('[data-iframe-modal]');

iframeModals.forEach((parent) => {
   const href = parent.getAttribute('href');
   const id = href ? href.replace('#', '') : null;
   const iframe = parent.querySelector('iframe');

   if (!id || !iframe) return;

   const newIframe = iframe.cloneNode(true);
   const originalSrc = iframe.getAttribute('src') || '';
   const baseSrc = originalSrc.split('?')[0];

   const newSrc = baseSrc + '?autoplay=1&controls=1&playsinline=0&background=0&muted=0&loop=0';
   newIframe.setAttribute('data-src', newSrc);
   newIframe.setAttribute('class', 'w-full h-full');

   // Style with important via setProperty
   newIframe.style.setProperty('transform', 'none', 'important');
   newIframe.style.setProperty('scale', 'none', 'important');

   const modal = document.createElement('div');
   modal.id = id;
   modal.classList.add(
      'hidden',
      'max-w-screen',
      'max-h-screen',
      'size-full',
      'bg-transparent!'
   );

   modal.appendChild(newIframe);
   parent.appendChild(modal);
});
